import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import { useTranslation } from "react-i18next";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import Category from '@material-ui/icons/Category';
import LockOpen from '@material-ui/icons/LockOpen';
import PermDataSettingIcon from '@material-ui/icons/PermDataSetting';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import PostAddIcon from '@material-ui/icons/PostAdd';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import DescriptionIcon from '@material-ui/icons/Description';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';

import DataService from "../../services/data.service";

import Authenticate from '../Authenticate/Authenticate';
import { Receipt, Shop } from '@material-ui/icons';
import InvoiceTable from '../Invoice/InvoiceTable';
import ProductCategoryTable from '../ProductCategory/ProductCategoryTable';
import ProductTable from '../Product/ProductTable';
import ClientTable from '../Client/ClientTable';
import PurchaseTable from '../Purchase/PurchaseTable';
import ProviderTable from '../Provider/ProviderTable';
import PaymentMethod from '../PaymentMethod/PaymentMethodTable';
import CollectTable from '../Collect/CollectTable';
import PaymentTable from '../Payment/PaymentTable';
import ClientDocumentTable from '../ClientDocument/ClientDocumentTable'
import CashTable from '../Cash/CashTable';
import CashAuxHead from '../Cash/CashAuxHead';
import InventoryTable from '../Inventory/InventoryTable';
import ConfigurationTable from '../Configuration/ConfigurationTable';
import UserPermissionTable from '../UserPermission/UserPermissionTable';
import UserTable from '../User/UserTable';
import BankTable from '../Bank/BankTable';
import DocumentTypeTable from '../DocumentType/DocumentTypeTable';
import ProfesionalTable from '../Profesional/ProfesionalTable';
import ReportForm from '../../components/Report/ReportForm';
import logo from '../../assets/img/logo.jpg'; // Tell webpack this JS file uses this image
import PermissionContext from '../../contexts/PermissionContext';
import ConfigContext from '../../contexts/ConfigContext';
//Payroll menus starting here
import PRTypeTable from '../PRType/PRTypeTable';
import PRConceptTable from '../PRConcept/PRConceptTable';
import PREmployeeMoveTable from '../PREmployeeMove/PREmployeeMoveTable';
import PayRollTable from '../PayRoll/PayRollTable';

const styles = (theme) => ({
    categoryHeader: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    categoryHeaderPrimary: {
        color: theme.palette.common.white,
    },
    item: {
        paddingTop: 1,
        paddingBottom: 1,
        color: 'rgba(255, 255, 255, 0.7)',
        '&:hover,&:focus': {
            backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
    },
    itemCategory: {
        backgroundColor: '#232f3e',
        boxShadow: '0 -1px 0 #404854 inset',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    firebase: {
        fontSize: 24,
        color: theme.palette.common.white,
    },
    itemActiveItem: {
        color: '#4fc3f7',
    },
    itemPrimary: {
        fontSize: 'inherit',
    },
    itemIcon: {
        minWidth: 'auto',
        marginRight: theme.spacing(2),
    },
    divider: {
        marginTop: theme.spacing(2),
    },
});



const ChildItem = (props) => {
    const { classes, key, icon, title, component, setContentComponent, setHeaderTitle, permission } = props
    const [active, setActive] = useState(false);

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')


    var clonedElementWithMoreProps = React.cloneElement(
        component, {
        permission: permission
    }
    );


    return (
        <ListItem
            key={key}
            button
            permission={permission}
            className={clsx(classes.item)}
            onClick={() => {
                setHeaderTitle(title)
                setContentComponent(clonedElementWithMoreProps)
                setActive(true)

            }
            }
            disabled={!hasPerm}
        >
            <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
            <ListItemText classes={{ primary: classes.itemPrimary, }}>
                {title}
            </ListItemText>
        </ListItem>
    )
}


function Navigator(props) {
    const { classes, setContentComponent, setHeaderTitle, ...other } = props;
    const { t } = useTranslation();
    const { configData } = useContext(ConfigContext)

    return (
        <Drawer variant="permanent" {...other}>
            <List disablePadding>
                <ListItem className={clsx(classes.firebase, classes.item, classes.itemCategory)}>
                    <Avatar alt="" src={logo} className={styles.large} />
                    {configData.company_name}
                </ListItem>

                <ListItem className={clsx(classes.item, classes.itemCategory)}>
                    <ListItemIcon className={classes.itemIcon}>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText
                        classes={{
                            primary: classes.itemPrimary,
                        }}
                    >
                        Menu
                    </ListItemText>
                </ListItem>
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_process")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="authenticate"
                    setContentComponent={setContentComponent}
                    active={true}
                    setHeaderTitle={setHeaderTitle}
                    icon={<LockOpen />}
                    component={<Authenticate />}
                    title={t("menu_authenticate")}
                    classes={classes}
                    permission={'user'}


                />
                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_sales")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="invoice"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Receipt />}
                    component={<InvoiceTable />}
                    title={t("menu_invoice")}
                    classes={classes}
                    permission={'invoice'}

                />
                <ChildItem
                    key="collect"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<MonetizationOnIcon />}
                    component={<CollectTable />}
                    title={t("menu_collect")}
                    classes={classes}
                    permission={'collect'}

                />
                <ChildItem
                    key="client_documents"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Receipt />}
                    component={<ClientDocumentTable />}
                    title={t("menu_client_document")}
                    classes={classes}
                    permission={'client-document'}

                />
                <ChildItem
                    key="client"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<SupervisorAccountIcon />}
                    component={<ClientTable />}
                    title={t("menu_client")}
                    classes={classes}
                    permission={'client'}

                />
                <ChildItem
                    key="client_document_report"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AssessmentIcon />}
                    component={<ReportForm reportGroup="sales" />}
                    title={t("menu_report")}
                    classes={classes}
                    permission={'sales-report'}

                />

                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_purchases")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="purchase"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Shop />}
                    component={<PurchaseTable />}
                    title={t("menu_purchase")}
                    classes={classes}
                    permission={'purchase'}

                />
                <ChildItem
                    key="payment"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<MonetizationOnIcon />}
                    component={<PaymentTable />}
                    title={t("menu_payment")}
                    classes={classes}
                    permission={'payment'}

                />
                <ChildItem
                    key="provider"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<SupervisorAccountIcon />}
                    component={<ProviderTable />}
                    title={t("menu_provider")}
                    classes={classes}
                    permission={'provider'}

                />
                <ChildItem
                    key="purchase_report"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AssessmentIcon />}
                    component={<ReportForm reportGroup="purchases" />}
                    title={t("menu_report")}
                    classes={classes}
                    permission={'purchase-report'}

                />
                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_inventory")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="inventory_move"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Shop />}
                    component={<InventoryTable />}
                    title={t("menu_inventory_move")}
                    classes={classes}
                    permission={"inventory"}

                />
                <ChildItem
                    key="product_category"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Category />}
                    component={<ProductCategoryTable />}
                    title={t("menu_product_category")}
                    classes={classes}
                    permission={"product-category"}

                />
                <ChildItem
                    key="product"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<PostAddIcon />}
                    component={<ProductTable />}
                    title={t("menu_product")}
                    classes={classes}
                    permission={"product"}

                />
                <ChildItem
                    key="inventory_report"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AssessmentIcon />}
                    component={<ReportForm reportGroup="inventory" />}
                    title={t("menu_report")}
                    classes={classes}
                    permission={'inventory-report'}
                />
                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_cash")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="cash_move"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Shop />}
                    component={<CashTable />}
                    title={t("menu_cash_move")}
                    classes={classes}
                    permission={"cash"}
                />
                <ChildItem
                    key="cash_move_aux"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Shop />}
                    component={<CashAuxHead />}
                    title={t("menu_cash_aux_move")}
                    classes={classes}
                    permission={"cash-aux"}
                />
                <ChildItem
                    key="payment_methods"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Category />}
                    component={<PaymentMethod />}
                    title={t("menu_payment_method")}
                    classes={classes}

                    permission={"payment-method"}
                />
                <ChildItem
                    key="banks"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AccountBalanceIcon />}
                    component={<BankTable />}
                    title={t("menu_bank")}
                    classes={classes}
                    permission={"bank"}
                />
                <ChildItem
                    key="cash_report"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AssessmentIcon />}
                    component={<ReportForm reportGroup="cash" />}
                    title={t("menu_report")}
                    classes={classes}
                    permission={'cash-report'}
                />
                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_payroll")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="payroll"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<GroupAddIcon />}
                    component={<PayRollTable />}
                    title={t("menu_payroll")}
                    classes={classes}
                    permission={'payroll'}

                />
                <ChildItem
                    key="employee_move"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Shop />}
                    component={<PREmployeeMoveTable />}
                    title={t("menu_employee_move")}
                    classes={classes}
                    permission={'employee_move'}

                />
                <ChildItem
                    key="employee"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<EmojiPeopleIcon />}
                    component={<ProfesionalTable />}
                    title={t("menu_employee")}
                    classes={classes}
                    permission={'employee'}

                />
                <ChildItem
                    key="pr-type"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<PermDataSettingIcon />}
                    component={<PRTypeTable />}
                    title={t("menu_pr_type")}
                    classes={classes}
                    permission={'pr-type'}

                />
                <ChildItem
                    key="pr-concept"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<Category />}
                    component={<PRConceptTable />}
                    title={t("menu_pr_concept")}
                    classes={classes}
                    permission={'pr-concept'}
                />
                <ChildItem
                    key="payroll-report"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<AssessmentIcon />}
                    component={<ReportForm reportGroup="payroll" />}
                    title={t("menu_report")}
                    classes={classes}
                    permission={'payroll-report'}
                />
                <Divider className={classes.divider} />
                <ListItem className={classes.categoryHeader}>
                    <ListItemText classes={{ primary: classes.categoryHeaderPrimary, }} >
                        {t("menu_configuration")}
                    </ListItemText>
                </ListItem>
                <ChildItem
                    key="configuration"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<PermDataSettingIcon />}
                    component={<ConfigurationTable />}
                    title={t("menu_configuration_move")}
                    classes={classes}
                    permission={"configuration"}

                />
                <ChildItem
                    key="document_types"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<DescriptionIcon />}
                    component={<DocumentTypeTable />}
                    title={t("menu_document_type")}
                    classes={classes}
                    permission={"document-type"}

                />
                <ChildItem
                    key="users"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<SupervisorAccountIcon />}
                    component={<UserTable />}
                    title={t("menu_users")}
                    classes={classes}
                    permission={"auth"}
                />
                <ChildItem
                    key="user_permission"
                    setContentComponent={setContentComponent}
                    setHeaderTitle={setHeaderTitle}
                    icon={<SupervisorAccountIcon />}
                    component={<UserPermissionTable />}
                    title={t("menu_user_permission")}
                    classes={classes}
                    permission={"permission"}
                />
                <Divider className={classes.divider} />
            </List>
        </Drawer>
    );
}

Navigator.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Navigator);